import { createFeature, createReducer, on } from '@ngrx/store';
import { LoginResponse, UserDataResult } from 'angular-auth-oidc-client';
import { Subscription } from '@emi/shared/models';
import * as authActions from './auth.actions';

export interface AuthState {
  loginResponse: LoginResponse,
  userData: UserDataResult,
  subscription: Subscription,
  subscriptions: Subscription[]
  subscriberJwt: string,
  accessToken: string,
}

export const authFeatureKey = 'auth';

export const initialAuthState: AuthState = {
  loginResponse: {
    isAuthenticated: false,
    userData: {},
    accessToken: '',
    idToken: '',
    configId: ''
  },
  userData: {
    userData: {},
    allUserData: []
  },
  subscription: {
    isDefaultLogin: false,
    id: 0,
    pkId: '',
    fullCompanyName: '',
    status: '',
    accessBegins: '',
    accessEnds: '',
    applicationId: 0,
    isDeleted: false,
    type: '',
    registrationType: 0
  },
  subscriptions: [],
  subscriberJwt: '',
  accessToken: ''
};

export const feature = createFeature(
{ 
  name: authFeatureKey,
  reducer: createReducer(
  initialAuthState,
  on(
    authActions.loginComplete,
    (state, { subscription, userData, loginResponse, subscriberJwt, subscriptions }) => {
      return {
        ...state,
        userData,
        loginResponse,
        subscription,
        subscriptions,
        subscriberJwt,
        accessToken: loginResponse.accessToken
      };
    }
  ),
  on(authActions.logoutComplete, (state) => {
    return {
      ...initialAuthState
    };
  }),
  on(authActions.updateAccessTokenComplete, (state, { accessToken }) => {
    return {
      ...state,
      accessToken
    };
  })
)});
